import React from "react";
import { SupTracker } from "@repo/core-ui";

export interface TxStatusProps {
  className?: string;
  value: "confirmed" | "stuck" | "processing" | "reverted" | "skipped";
}

const statusColors = {
  confirmed: "success",
  processing: "info",
  stuck: "warning",
  reverted: "error",
  skipped: "primary-active",
} as const;

export function SupTxStatus({ className, value }: TxStatusProps) {
  return (
    <SupTracker variant={statusColors[value]} className={className}>
      {value}
    </SupTracker>
  );
}
